import React from 'react';
import { Icon } from 'elements';

const Menu = ({size, className}) => (
  <Icon size={size} className={className}>
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
  </Icon>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/core/icons/components/Menu.jsx